/**
 * «Ver dónde» de «Lo que se dedujo»: las piezas de un material (por expressID) → el mapa de color que el visor 3D
 * ya sabe pintar (`instColores`). Solo es VISTA: no toca selección, cantidades ni pesos.
 */
export type TonoResaltado = 'accent';

export function coloresDeMaterial(expressIds: readonly number[] | null | undefined): ReadonlyMap<number, TonoResaltado> | null {
  if (!expressIds || expressIds.length === 0) return null;
  return new Map(expressIds.map((id) => [id, 'accent' as const]));
}
